export const SIZE_SMALLER = "smaller";
